<div class="skymiles-benefits-section__container__details__goodies">
  <div
    *ngFor="let item of content.stacks[index].goodies"
    class="skymiles-benefits-section__container__details__goodies__item"
  >
    <idp-image
      class="skymiles-benefits-section__container__details__goodies__image"
      [content]="item.icon"
    ></idp-image>
    <div>
      <div
        class="skymiles-benefits-section__container__details__goodies__name"
        aria-hidden="true"
      >
        <span [innerHTML]="item.name"></span>
      </div>
      <a
        [className]="
          'skymiles-benefits-section__container__details__goodies__link skymiles-benefits-section__container__details__goodies__link_' +
          content.stacks[index].tier
        "
        *ngIf="item.link"
        [href]="item.link.url"
        target="_blank"
      >
        {{ item.link.label }}
      </a>
    </div>
  </div>
</div>
